import { Auditable, Case, QueryParams, SortParams } from "..";

export interface CallBack extends Auditable {
    name: string;
    caseId: number;
    userId: number;
    userName: string;
    scheduledTime: string;
    note: string;
    isPendingFollowUp: boolean;
    completedOn?: string;

    isComplete?: boolean; // auto-calculated on API
    case?: Case;
}

export const DefaultCallBackQueryParams: QueryParams = {
    caseId: "",
    includeComplete: "false",
};

export const DefaultCallBackSortParams: SortParams = {
    orderBy: "scheduledTime",
    orderDesc: "false",
};
